/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useCommunityList from '../../../hooks/useCommunityList';
import useLogin from '../../../../src/hooks/useAuth';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import { FastField, Formik, Form, Field } from 'formik';
import {
  Grid,
  List,
  ListItem,
  Button,
  Typography,
  InputLabel,
  Box,
  Tab,
  Container,
  InputBase,
  InputAdornment,
  TextField,
  Popover,
  Paper,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from '@material-ui/core';

const AdminRejection = () => {
  const { approveVideo, getVideoRequestDataForApproval } = useCommunityList();
  const { requestId } = useParams();
  const [approvalStatus, setApprovalStatus] = useState(null);
  const [reason, setRejectReason] = useState('');
  const [userDataFetched, setUserDataFetched] = useState(false); // Track if user data has been fetched

  const key = 'iFrasCwdJh';
  let bytes = null;
  let loggedInUserData = null;
  const userCookie = Cookies.get('user');
  if (userCookie) {
    bytes = CryptoJS.AES.decrypt(userCookie, key);
    loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }

  const { getRoleData } = useLogin();
  const [userData, setUserData] = useState();
  const [videoData, setVideoData] = useState(null);

  useEffect(() => {
    if (userCookie && !userDataFetched) {
      // Fetch user data only if not fetched
      const fetchUserData = async () => {
        const userDataResult = await getRoleData({
          userId: loggedInUserData.id,
        });
        setUserData(userDataResult.usersResult);
        setUserDataFetched(true); // Mark user data as fetched
      };
      fetchUserData();
    }
  }, [userCookie, getRoleData, loggedInUserData, userDataFetched]);

  console.log(userData, 'UDI');

  const fetchVideoData = async () => {
    try {
      const response = await getVideoRequestDataForApproval({ requestId: requestId }); // Use communityId

      if (response.status === true) {
        // Video data is available, you can use response.data to access it
        const data = response.data;
        setVideoData(data);
      } else {
        // Handle API request errors
        console.error('Failed to fetch video data');
        setVideoData();
      }
    } catch (error) {
      // Handle other errors, e.g., network issues or unexpected exceptions
      console.error('Async function error:', error);
    }
  };

  useEffect(() => {
    // Call the function when the component mounts
    fetchVideoData();
  }, []); // Add communityId as a dependency

  const handleReject = () => {
    if (reason && userData?.emailId) {
      approveVideo({
        requestId: requestId,
        action: 'reject',
        reason: reason,
        communityRepEmail: userData.emailId,
        userName: userData.firstName,
      })
        .then((response) => {
          if (response.status === true) {
            setApprovalStatus('Rejected');
          } else {
            setApprovalStatus('Rejection Failed');
          }
        })
        .catch((error) => {
          console.error('Rejection failed:', error);
          setApprovalStatus('Rejection Failed');
        });
    }
  };
  console.log(approvalStatus, 'RRR');

  if (videoData && videoData.approvedStatus === 'Approved') {
    // If the video is already approved, display the message
    return (
      <Box className="FullWidthPattern">
        <Container>
          <Box className="PageSpacing FixedMD">
            <Box className="InvitationWrapper">
              <Grid container alignItems="center" justifyContent="center">
                <Grid item xs={12}>
                  <Typography variant="h2" component="div">
                    The video has already been approved
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Container>
      </Box>
    );
  }
  return (
    <Formik>
      <Box className="FullWidthPattern">
        <Container>
          <Box className="PageSpacing FixedMD">
            <Box className="InvitationWrapper">
              <Grid container alignItems="center" justifyContent="center">
                <Grid item xs={12} className="commonFieldBox">
                  <InputLabel className="InputLabelFld" htmlFor="email">
                    Enter reject reason
                    <Box mb={1} component="span" display="inline-block" className="Asterisk">
                      *
                    </Box>
                  </InputLabel>
                  <TextField
                    name="reason"
                    id="outlined-basic"
                    variant="outlined"
                    type="text"
                    onChange={(e) => setRejectReason(e.target.value)}
                    value={reason}
                    // error={!!showErrIfTouched('emailId', errors, touched)}
                    // helperText={showErrIfTouched('emailId', errors, touched)}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <Box className="Wrapper ButtonWrapper">
                    <Button
                      disabled={!userData}
                      type="submit"
                      className="Button EditViewButton RejectViewButton"
                      variant="contained"
                      color="primary"
                      onClick={handleReject}
                    >
                      Reject
                    </Button>
                  </Box>
                </Grid>
              </Grid>
              {approvalStatus === 'Rejected' ? (
                <div>Rejected</div>
              ) : (
                <div style={{ paddingLeft: '210px' }}>
                  {/* {!userData ? 'You are not authorized to take this action' : null} */}
                </div>
              )}
            </Box>
          </Box>
        </Container>
      </Box>
    </Formik>
  );
};

export default AdminRejection;
